import { coinAPI } from "../api/api";
import { SET_CURRENCIES, SET_HISTORY, SET_MAX_PAGE } from "./types";

export const setCurrencies = (newCurrencies) => ({
  type: SET_CURRENCIES,
  payload: { newCurrencies },
});

export const setMaxPage = (page) => ({
  type: SET_MAX_PAGE,
  payload: { page },
});

const setHistory = (historyData) => ({
  type: SET_HISTORY,
  payload: { historyData },
});

export const getCurrencies = (page) => {
  return async (dispatch) => {
    const response = await coinAPI.getCurrencies(page);
    dispatch(setCurrencies(response.data.data));
  };
};

export const getHistoryPrices = (id) => {
  return async (dispatch) => {
    const response = await coinAPI.getCurrencyHistory(id);
    dispatch(setHistory(response.data.data));
  };
};
